import React, { isValidElement, cloneElement, useState, useEffect, ReactElement, useContext } from "react";

import IcomoonReact from "icomoon-react"
import iconSet from "../../selection.json";
import { ThemeContext } from "./theme-toggle";

const icons: Record<string, string[]> = {
  light: [],
  dark: [],
  'light-hover': [],
  'dark-hover': []
}

for (const icon of iconSet.icons) {
  const name = icon.properties.name;

  if (name.endsWith('dark')) {
    icons.dark.push(name);
  } else if(name.endsWith('dark-hover')) {
    icons['dark-hover'].push(name)
  } else if (name.endsWith('hover')) {
    icons['light-hover'].push(name);
  } else {
    icons.light.push(name)
  }
}

const Icon: React.FC<{
  color?: string,
  size: string | number,
  icon: string,
  isActive?: boolean,
  className?: string,
  children: ReactElement
}> = ({ color, size = '100%', isActive = false, icon, children, className = '' }) => {
  const [hover, setHover] = useState(false)
  const { theme } = useContext(ThemeContext) || 'light';
  const [newName, setNewName] = useState(() => theme === 'dark' && icons.dark.includes(icon) ? `${icon}-dark` : icon)

  useEffect(() => {
    const hoverName = hover || isActive ? '-hover' : '';
    const themeName = theme === 'dark' ? '-dark' : '';

    if (icons[`${theme}${hoverName}`]?.includes(`${icon}${themeName}${hoverName}`)) {
      setNewName(`${icon}${themeName}${hoverName}`);
    } else if (hover && icons['light-hover'].includes(`${icon}${hoverName}`) && !icons.dark.includes(`${icon}${themeName}`)) {
      setNewName(`${icon}${hoverName}`);
    }
  }, [hover, theme, isActive])

  const Image = <IcomoonReact
    className={className}
    iconSet={iconSet}
    color={color}
    size={size}
    icon={newName}
    fill="#464646"
    stroke="#B8B8B8"
  />

  return isValidElement(children) ? cloneElement(children, {
    children: (
      <>
        {Image}
        {children.props.children}
      </>
    ),
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => { 
      setHover(false);
      setNewName(newName.replace('-hover', ''));
    },
  }) : Image
};

export default Icon;